import { AdmService } from 'src/app/shared/services/adm.service';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { BuscadorPA } from 'src/app/shared/models/buscadorPA';
import { ClasePorEstado, isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { Compania } from 'src/app/shared/models/compania';
import { ConfigService } from 'src/app/shared/services/config.service';
import { debounceTime, distinctUntilChanged, filter, finalize, forkJoin, startWith, switchMap, tap } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ParametrosService } from 'src/app/shared/services/parametros.service';

import { PedidoAbastecimientoCabecera } from 'src/app/shared/models/pedidoAbastecimientoCabecera';
import { PAService } from 'src/app/shared/services/pa.service';

import { ProductosService } from 'src/app/shared/services/productos.service';
import { Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SelectorDivisionesComponent } from 'src/app/shared/components/selector-divisiones/selector-divisiones.component';
import { SelectorEstadoPedidosComponent } from 'src/app/shared/components/selector-estado-pedidos/selector-estado-pedidos.component';
import { SelectorRegionesComponent } from 'src/app/shared/components/selector-regiones/selector-regiones.component';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { ZonaVendedor } from 'src/app/shared/models/zonaVendedor';
import { Division } from 'src/app/shared/models/division';
import { Estado } from 'src/app/shared/models/estado';
import { Region } from 'src/app/shared/models/region';

@Component({
  selector: 'app-pa-buscador',
  templateUrl: './pa-buscador.component.html'
})
export class PABuscadorComponent {
  @ViewChild(SelectorDivisionesComponent, { static: true }) selectorDivision: SelectorDivisionesComponent;
  @ViewChild(SelectorRegionesComponent, { static: true }) selectorRegion: SelectorRegionesComponent;
  @ViewChild(SelectorEstadoPedidosComponent, { static: true }) selectorEstadoPedido: SelectorEstadoPedidosComponent;
  @ViewChild('matSortPA') matSortPA: MatSort;
  @ViewChild('matPaginatorPA') matPaginatorPA: MatPaginator;
  displayedColumnsPA = ['acciones', 'nroPedido', 'nroOrdenSAP', 'nroCliente', 'nombreCliente', 'estado', 'fechaEstado', 'terminoPago', 'idZonaVendedor', 'nombreDistribuidor','enviadoDistribuidor', 'total', 'totalLocal', 'fechaCreacion'];
  dataSourcePA = new MatTableDataSource<PedidoAbastecimientoCabecera>();

  filteredOptions: any;
  formControlAutocomplete = new FormControl('');
  hint: string = ""
  isLoading = false;
  minLengthTerm = 2;
  autocompletableZonaVendedor: boolean = true;
  buscadorPA: BuscadorPA;
  userName = this.loggedService.logged.userName;

  rolesConRegion: ItemParametro[] = [];
  selectRegiones: boolean = true;
  zonaVendedorSeleccionada: ZonaVendedor = null;
  companias: Compania[] = [];
  salesOrgs: SalesOrg[] = [];
  motivosRetencion: ItemParametro[] = []
  fDesde: Date | null;
  fHasta: Date | null
  alta: boolean = false;
  divisionSeleccionada: Division = null
  estadoSeleccionado: Estado = null
  regionSeleccionada: Region = null
  
  constructor(private configService: ConfigService,
    private dialog: MatDialog,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private productosService: ProductosService,
    private snackBarService: SnackbarService,
    private parametrosService: ParametrosService,
    private paService: PAService,
    private admService: AdmService,
    private tablasService: TablasService) { }

  public Tooltips: {
    Eliminar: string
    Editar: string
    Ver: string;
  }

  public Etiquetas: {

    Acciones: string
    Buscar: string
    Compania: string
    Estado: string
    FechaCreacion: string
    FechaDesde: string
    FechaEstado: string,
    FechaHasta: string
    IdZonaVendedor: string
    EnviadoDistribuidor: string;
    MotivoRetencion: string
    NombreCliente: string,
    NombreDistribuidor: string;
    NroCliente: string
    NroOrdenSAP: string
    NroPedido: string;
    Path: string
    SalesOrg: string
    SinRegistros: string
    TerminoPago: string,
    Titulo: string
    Total: string,
    TotalLocal: string
    BuscarVendedor: string,

  }
  ngAfterViewInit() {
    this.dataSourcePA.paginator = this.matPaginatorPA;
    this.dataSourcePA.sort = this.matSortPA;
    this.dataSourcePA.sort.disableClear = true;
  }


  ngOnInit() {
    const buscadorData = sessionStorage.getItem('buscadorPA');
    if (buscadorData) {
      // Recuperar el objeto y mapear las fechas a tipo Date
      const buscador: BuscadorPA = Object.assign(new BuscadorPA(), JSON.parse(buscadorData));

      // Convertir campos de fecha
      buscador.fDesde = new Date(buscador.fDesde);
      buscador.fHasta = new Date(buscador.fHasta);

      
      this.buscadorPA = buscador;
      if (this.buscadorPA.idZonaVendedor != '-1') {
        this.zonaVendedorSeleccionada = new ZonaVendedor();
        this.zonaVendedorSeleccionada.displayValue = this.buscadorPA.idZonaVendedor + ' - ' + this.buscadorPA.zonaVendedor
      }
      this.buscadorPA.nroPedido = Number(buscador.nroPedido)
      
      if (this.buscadorPA.idDivision != "-1") {
        this.divisionSeleccionada = new Division()
        this.divisionSeleccionada.id = this.buscadorPA.idDivision;
      }
      if (this.buscadorPA.idRegion != "-1") {
        this.regionSeleccionada = new Region()
        this.regionSeleccionada.id = this.buscadorPA.idRegion;
      }
      if (this.buscadorPA.idEstado != -1) {
        this.estadoSeleccionado = new Estado()
        this.estadoSeleccionado.id = this.buscadorPA.idEstado.toString();
      }
      this.buscadorPA.idMotivoRetencion = buscador.idMotivoRetencion

    }else {
      this.buscadorPA = new BuscadorPA();
    }

    this.dataSourcePA.data = [];

    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,
      Eliminar: this.configService.tooltips.Eliminar,

      Ver: this.configService.tooltips.Ver
    }

    this.Etiquetas = {

      Acciones: this.configService.etiquetas.Acciones,
      Buscar: this.configService.etiquetas.Buscar,
      Compania: this.configService.etiquetas.Compania,
      Estado: this.configService.etiquetas.Estado,
      FechaCreacion: this.configService.etiquetas.FechaCreacion,
      FechaDesde: this.configService.etiquetas.FechaDesde,
      FechaEstado: this.configService.etiquetas.FechaEstado,
      FechaHasta: this.configService.etiquetas.FechaHasta,
      IdZonaVendedor: this.configService.etiquetas.IdZonaVendedor,
      MotivoRetencion: this.configService.etiquetas.MotivoRetencion,
      NombreCliente: this.configService.etiquetas.NombreCliente,
      NombreDistribuidor: this.configService.etiquetas.NombreDistribuidor,
      NroCliente: this.configService.etiquetas.NroCliente,
      NroOrdenSAP: this.configService.etiquetas.NroOrdenSAP,
      EnviadoDistribuidor: this.configService.etiquetas.EnviadoDistribuidor,
      NroPedido: this.configService.etiquetas.NroPedido,
      Path: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Path,
      SalesOrg: this.configService.etiquetas.SalesOrg,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      TerminoPago: this.configService.etiquetas.TerminoPago,
      Titulo: this.configService.etiquetas.PedidosAbastecimiento.Buscador.Titulo,
      Total: this.configService.etiquetas.Total,
      TotalLocal: this.configService.etiquetas.TotalLocal,
      BuscarVendedor: this.configService.etiquetas.BuscarVendedor,

    }
    // this.buscadorPA = new BuscadorPA();
    this.formControlAutocomplete = new FormControl();
    this.formControlAutocomplete.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTerm
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.filteredOptions = [];
          this.isLoading = true;
        }),
        switchMap(value => this.admService.cZonasVendedoresAutocompleteSearch(this.loggedService.logged.idPais, this.buscadorPA.idCompania, this.buscadorPA.idSalesOrg, value)
          .pipe(
            finalize(() => {
              this.isLoading = false
            }),
          )
        )
      )
      .subscribe((data: ZonaVendedor[]) => {
        this.filteredOptions = data;

      });
    this.buscadorPA.idPais = this.loggedService.logged.idPais;
    if (this.buscadorPA.fDesde == null) {
    this.buscadorPA.fHasta = new Date();
    const fechaDesdeDate = new Date();
    fechaDesdeDate.setMonth(fechaDesdeDate.getMonth() - 4);
    this.buscadorPA.fDesde = fechaDesdeDate;
    }

    forkJoin([
      this.admService.cCompanias(this.loggedService.logged.idPais),
      this.admService.cSalesOrgs(this.loggedService.logged.idPais, this.loggedService.logged.idCompania),
      this.parametrosService.cItemsParametros(10), //MotivosRetencion
      this.parametrosService.cItemParametroXDescripcionItem(25, "PA"), //Cambiar descripcionItem segun tipo de pedido
      this.parametrosService.cItemsParametros(67) //Roles Alta abastecimiento


    ]).subscribe((data: [Compania[], SalesOrg[], ItemParametro[], ItemParametro, ItemParametro[]]) => {

      if (data[0].length) {

        this.companias = data[0];
        this.buscadorPA.idCompania = data[0][0].id;
      }

      if (data[1].length) {

        this.salesOrgs = data[1];
        this.buscadorPA.idSalesOrg = data[1][0].id;
      }

      if (data[2].length) {

        this.motivosRetencion = data[2];

      }
      if (data[3] != null) {
        if (data[3].idItem.length) {
          this.buscadorPA.idTipoOrden = data[3].idItem;
        }
      }
      if (data[4] != null) {
        if (data[4].length) {
          if (this.loggedService.validToken()) {
            data[4].forEach(rol => {
              if (this.loggedService.logged.rol == rol.idItem && !this.alta) {
                this.alta = true;
              }
            });
          }
        }
      }

      this.selectorDivision.cDivisiones(this.loggedService.logged.idPais, this.companias[0].id, this.salesOrgs[0].id, this.loggedService.logged.userName);
      this.selectorEstadoPedido.cEstados(this.loggedService.logged.idPais, "7");

      if (!this.loggedService.logged.idRegion.length) {
        this.selectorRegion.cRegiones(this.loggedService.logged.idPais);
        this.selectRegiones = true;
      }
      else {
        this.buscadorPA.idRegion = this.loggedService.logged.idRegion;
        this.selectRegiones = false;
      }

      if (!this.loggedService.logged.idZonaVendedor.length) {
        if (this.isInRole('VENDEDOR')) {
          this.buscadorPA.idZonaVendedor = null;
          this.buscadorPA.zonaVendedor = null;
          this.autocompletableZonaVendedor = false;
        }
        else {
          this.autocompletableZonaVendedor = true;
        }
      }
      else {
        this.buscadorPA.idZonaVendedor = this.loggedService.logged.idZonaVendedor;
        this.buscadorPA.zonaVendedor = this.loggedService.logged.zonaVendedor;
        this.autocompletableZonaVendedor = false;
      }
      if (this.loggedService.logged.nroClienteDistribuidor != null && this.loggedService.logged.nroClienteDistribuidor !== '') {
        this.buscadorPA.nroClienteDistribuidor = this.loggedService.logged.nroClienteDistribuidor; // solo los distribuidores vienen con nroClienteDistribuidor

      }else{
        this.buscadorPA.nroClienteDistribuidor = '-1'
      }
      let timer = setTimeout(() => {
        this.buscar(0);
      }, 250);


    });
  }

  buscar(idTipoMensaje: number) {
    sessionStorage.setItem('buscadorPA', JSON.stringify(this.buscadorPA));
    if (!this.buscadorPA.nroPedido) {
      this.buscadorPA.nroPedido = 0;
    }
    this.buscadorPA.fDesde.setHours(0, 0, 0);
    this.buscadorPA.fHasta.setHours(0, 0, 0);
    this.paService
      .cPedidosAbastecimiento(this.buscadorPA)
      .subscribe((data: PedidoAbastecimientoCabecera[]) => {
        this.dataSourcePA.data = [];
        if (data.length) {

          this.dataSourcePA.data = data;
          this.cAcciones();

          switch (idTipoMensaje) {
            case 1:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 1)
              break;
            case 2:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 1)
              break;
            case 3:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 1)
              break;

          }
        }

      })

  }

  cAcciones() {
    this.dataSourcePA.data.forEach(pa => {
      if (pa.idEstado == 1 && (pa.usuarioRedSolicitante == this.userName || this.isInRole('ADMVENTAS') || this.isInRole('ADM LOCAL') || this.isInRole('ADM'))) {
        pa.editar = true;
      }
      if (!pa.editar) {
        if (pa.idEstado != 1 || pa.usuarioRedSolicitante != this.userName) {
          pa.ver = true;
        }
      }
    });
  }

  applyFilterPA(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourcePA.filter = filterValue.trim().toLowerCase();
  }

  recibirDivisionEmitida(division: any) {
    if (typeof division != 'undefined') {
      this.divisionSeleccionada = division;
      if (division != this.buscadorPA.idDivision) {
        this.buscadorPA.idDivision = division.toString();
      }
    }
  }

  recibirRegionEmitida(region: any) {
    if (typeof region != 'undefined') {
      this.regionSeleccionada = region;
      if (region != this.buscadorPA.idRegion) {
        this.buscadorPA.idRegion = region.toString();
      }
    }
  }

  recibirEstadoEmitido(estado: any) {
    if (typeof estado != 'undefined') {
      this.estadoSeleccionado = estado;
      if (estado != this.buscadorPA.idEstado) {
        this.buscadorPA.idEstado = estado;
      }
    }
  }


  getOptionText(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  seleccionarVendedor(zv: any) {
    this.zonaVendedorSeleccionada = zv;
    this.buscadorPA.idZonaVendedor = this.zonaVendedorSeleccionada.id;
    this.buscadorPA.zonaVendedor = this.zonaVendedorSeleccionada.descripcion;

  }

  handleEmptyInputVendedor(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTerm) {
      this.limpiarVendedor(false);
    }
  }


  clasePorEstado(id: string) {
    let clase = ClasePorEstado("7", id);
    return clase;
  }

  limpiarVendedor(resetFormControl: boolean) {
    this.filteredOptions = [];
    this.zonaVendedorSeleccionada = null;
    this.buscadorPA.idZonaVendedor = "-1";
    if (resetFormControl) {
      this.formControlAutocomplete.setValue('');

    }

  }

  pa(codigo: number, idTipo: number) {

    this.router.navigate([this.configService.etiquetas.PedidosAbastecimiento.PA.Path], {
      queryParams: {
        codigo: codigo, //Si es distinto de cero es edicion/ver,
        idTipo: idTipo //1 = nuevo, 2 = edición, 3: ver
      }
    });
  }
  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }


}
